import fetcher from 'api/fetcher';
import { getStatusByCampaigns } from 'utils/campaign';
import { CampaignDTO, mappingCampaignStateFromDTO } from 'utils/campaign/mappers';
import { NotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import { setPage } from 'store/autoReducers';
import { CampaignLoadState, CampaignTabStatus, setCampaigns, setLoadCampaigns } from 'store/models/dashboard';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type FetchCampaignsNextPage = (options: {
    currentStatus: CampaignTabStatus;
    isCampaignSearch?: boolean;
    isFilters?: boolean;
    abortSignal?: AbortSignal;
}) => AppThunkAction<Promise<void> | null>;

export const fetchCampaignsNextPage: FetchCampaignsNextPage = ({
    currentStatus,
    isFilters,
    isCampaignSearch = false,
    abortSignal,
}) => {
    return (dispatch, getState) => {
        const { isLoad, campaigns, campaignSearchValue, appliedFilters } = getState().dashboard;
        const page = getState().campaignPage;

        if ([CampaignLoadState.Loading, CampaignLoadState.Disabled].includes(isLoad)) {
            return null;
        }

        dispatch(setLoadCampaigns(CampaignLoadState.Loading));
        const newPage = page + 1;

        const queryStr = urlParser.stringify({
            pageType: currentStatus,
            nameFilter: campaignSearchValue,
            page: newPage,
            productType: appliedFilters.productTypes || null,
            campaignStatus: appliedFilters.campaignStatuses || null,
            budgetStatus: appliedFilters.budgetStatuses || null,
            moderationStatus: appliedFilters.moderationStatuses || null,
            area: appliedFilters.areas || null,
            professionalRoles: appliedFilters.professionalRoles || null,
            createdByUserIds: appliedFilters.createdByUserIds || null,
        });

        return fetcher
            .get<unknown, CampaignDTO[]>(`/api/v1/campaigns?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((campaignsByPage) => {
                const mappedCampaigns = campaignsByPage.map(mappingCampaignStateFromDTO);
                const newCampaigns =
                    isCampaignSearch || isFilters ? mappedCampaigns : campaigns.concat(mappedCampaigns);
                dispatch([
                    setPage(newPage),
                    setCampaigns(newCampaigns),
                    setLoadCampaigns(getStatusByCampaigns(campaignsByPage)),
                ]);
            })
            .catch(() => {
                if (!abortSignal?.aborted) {
                    dispatch([setPage(0), setCampaigns([]), setLoadCampaigns(CampaignLoadState.Success)]);
                }
                if (isCampaignSearch) {
                    dispatch(addNotification(NotificationName.CampaignsSearchSomethingWentWrong));
                } else if (isFilters) {
                    dispatch(addNotification(NotificationName.DashboardFiltersSomethingWentWrong));
                } else {
                    dispatch(addNotification(NotificationName.DashboardCampaignListSomethingWentWrong));
                }
            });
    };
};
